import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";

export function useSites() {
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState(localStorage.getItem("wp_site_id") || "");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/wp/sites");
      setSites(data);
      if (data.length && !data.find((s) => s.site_id === localStorage.getItem("wp_site_id"))) {
        setSiteId(data[0].site_id);
      }
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const pick = (id) => { setSiteId(id); localStorage.setItem("wp_site_id", id); };
  const site = sites.find((s) => s.site_id === siteId) || null;
  return { sites, site, siteId, pick, reload: load, loading };
}

export const SitePicker = ({ sites, siteId, onPick, filter }) => {
  const shown = filter ? sites.filter(filter) : sites;
  return (
    <div className="flex items-center gap-2">
      <Select value={siteId || ""} onValueChange={onPick}>
        <SelectTrigger className="w-72" data-testid="site-picker">
          <SelectValue placeholder="Select a site…" />
        </SelectTrigger>
        <SelectContent>
          {shown.map((s) => (
            <SelectItem key={s.site_id} value={s.site_id}>
              {s.name} — {s.url.replace(/^https?:\/\//, "")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {shown.length === 0 && (
        <Badge variant="outline" className="bg-amber-50 text-amber-800 border-amber-200">
          No sites connected yet — add one under WordPress API → Sites
        </Badge>
      )}
    </div>
  );
};
